export const PROJECT_NO_VIEWS = {
    name            : 'No views',
    icon            : 'ii5-task-list', //'i5-sticky-note',
    // iconLight       : 'ii5-task-list', //'i5-document-light',
    // image           : 'notes-docs',
    // iconSvg         : 'isvg-pages',
    url             : 'no-views',
    // stringId        : 'page',
    // description     : 'Page view description',
    // menuName        : 'Page',
    inheritance     : false,
}
